var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card_ngo bg-white"},[_c('div',[_c('img',{attrs:{"src":("" + (_vm.logo ? _vm.logo : '@/assets/images/logo/logo_d.jpg')),"alt":"logo"}})]),_c('div',{staticClass:"name_ngo"},[_c('h3',[_vm._v(_vm._s(_vm.name_ngo))])]),_c('router-link',{staticClass:"rm",attrs:{"to":{
      name: 'ngo-home',
      params: { id: _vm.id },
    }}},[_c('div',{staticClass:"display_ngo"},[_c('h3',[_vm._v("عرض معلومات المنظمة")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }